import React, { Component } from 'react';
import './CriteriaMenuBar.css'
import Config from './Configs/criteria.json';

export default class CriteriaMenuBar extends Component {
    constructor(props) {
        super(props);

    }
    handleOnClick = (section) => (e) => {
        this.props.onMenuChange(section);
    }
    getNumberOfSelectedItemByType = (type) => {
        let count = 0;
        for (let i = 0; i < this.props.criteria.advanced[type].length; i++) {
            if (this.props.criteria.advanced[type][i].selected) {
                count++;
            }
        }
        return count;
    }
    render() {
        const section = this.props.section;
        return (
            <div className="CriteriaMenuBar">
                <div className="cntErrorMsg" style={{ display: this.props.showErrMsg === "on" ? "block" : "none" }} >{Config.CountErrMsg}</div>

                <ul>
                    <li className={section === "basic" ? "selected" : ""} onClick={this.handleOnClick("basic")}>基本情報</li>
                    <li className={section === "financial" ? "selected" : ""} onClick={this.handleOnClick("financial")}><div className="wrapper"><div className="text">財務</div><div className="counter" style={{ display: this.getNumberOfSelectedItemByType("financial") > 0 ? "block" : "none" }}>{this.getNumberOfSelectedItemByType("financial")}</div></div></li>
                    <li className={section === "consensus" ? "selected" : ""} onClick={this.handleOnClick("consensus")}><div className="wrapper"><div className="text">コンセンサス</div><div className="counter" style={{ display: this.getNumberOfSelectedItemByType("consensus") > 0 ? "block" : "none" }}>{this.getNumberOfSelectedItemByType("consensus")}</div></div></li>
                    <li className={section === "priceperf" ? "selected" : ""} onClick={this.handleOnClick("priceperf")}><div className="wrapper"><div className="text">株価パフォーマンス</div><div className="counter" style={{ display: this.getNumberOfSelectedItemByType("priceperf") > 0 ? "block" : "none" }}>{this.getNumberOfSelectedItemByType("priceperf")}</div></div></li>
                    <li className={section === "technical" ? "selected" : ""} onClick={this.handleOnClick("technical")}><div className="wrapper"><div className="text">テクニカル</div><div className="counter" style={{ display: this.getNumberOfSelectedItemByType("technical") > 0 ? "block" : "none" }}>{this.getNumberOfSelectedItemByType("technical")}</div></div></li>
                    <li className={section === "other" ? "selected" : ""} onClick={this.handleOnClick("other")}><div className="wrapper"><div className="text">その他</div><div className="counter" style={{ display: this.getNumberOfSelectedItemByType("other") > 0 ? "block" : "none" }}>{this.getNumberOfSelectedItemByType("other")}</div></div></li>
                </ul>
            </div>
        );
    }
}